import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Star, ExternalLink } from "lucide-react";

export function Stars({ n, testid }) {
  if (!n) return <span className="text-[11px] text-slate-400" data-testid={testid}>No rating</span>;
  return (
    <span className="inline-flex" data-testid={testid} title={`${n} out of 5`}>
      {[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`w-3.5 h-3.5 ${i <= n ? "fill-emerald-500 text-emerald-500" : "text-slate-300"}`} />)}
    </span>
  );
}

export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—");
export const tpLink = (r) => r.url || `https://uk.trustpilot.com/review/thehottubsuperstore.co.uk?search=${encodeURIComponent(r.reviewer_name || "")}`;

export function CustomerTrustpilotReviews({ customerId }) {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get(`/reviews/customer/${customerId}`).then((r) => setItems(r.data.items)).catch(() => setItems([])); }, [customerId]);
  if (!items) return null;
  return (
    <section className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5" data-testid="user-trustpilot-reviews">
      <h2 className="text-sm font-bold text-slate-900 mb-3 flex items-center gap-2"><img src="/brand/trustpilot-logo-black.svg" alt="Trustpilot" className="h-4 w-auto" data-testid="customer-trustpilot-logo" /> Reviews <span className="text-xs font-normal text-slate-400">{items.length}</span></h2>
      {!items.length && <p className="text-sm text-slate-400" data-testid="user-reviews-empty">No linked reviews.</p>}
      <ul className="space-y-3">
        {items.map((r) => (
          <li key={r.id} className="border-t border-slate-100 pt-3 first:border-0 first:pt-0" data-testid={`user-review-${r.id}`}>
            <div className="flex items-center gap-2"><Stars n={r.stars} /><span className="text-xs text-slate-400">{fmtDate(r.review_date)}</span>
              {r.job_legacy_id && <a href={`/tasks/${r.job_legacy_id}`} className="text-xs text-indigo-600 hover:underline">Job {r.job_legacy_id}</a>}
              <a href={tpLink(r)} target="_blank" rel="noreferrer" className="ml-auto text-xs text-slate-500 hover:text-indigo-600 inline-flex items-center gap-1" data-testid={`user-review-link-${r.id}`}>Trustpilot <ExternalLink className="w-3 h-3" /></a></div>
            <div className="text-sm font-semibold text-slate-800 mt-1">{r.title}</div>
            <p className="text-sm text-slate-600 whitespace-pre-line">{r.text}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
